// Este es usado para guardar los paquetes por aseguradora cuando vengan.
// export default 'SET_INSURANCE_CARRIER_RESPONSES';
export const SET_FILTER_COVERAGE = 'SET_FILTER_COVERAGE';
export const SET_FILTER_COMPANY = 'SET_FILTER_COMPANY';
export const SET_FILTER_PREMIUM_START = 'SET_FILTER_PREMIUM_START';
export const SET_FILTER_PREMIUM_END = 'SET_FILTER_PREMIUM_END';
export const SET_FILTER_SORT_BY = 'SET_FILTER_SORT_BY';
export const RESET_FILTERS = 'RESET_FILTERS';
export const RESET_COMPARATION_QUOTATIONS = 'RESET_COMPARATION_QUOTATIONS';
export const SET_SELECTED_PACKAGES = 'SET_SELECTED_PACKAGES';

export const COMPARATION_PAGE_INITIALIZE_EXPECTED_PACKAGE_RESPONSES = 'COMPARATION_PAGE_INITIALIZE_EXPECTED_PACKAGE_RESPONSES';
export const COMPARATION_PAGE_ADD_PACKAGE_RESPONSE = 'COMPARATION_PAGE_ADD_PACKAGE_RESPONSE';
export const COMPARATION_PAGE_SET_PETITION_ALIVE = 'COMPARATION_PAGE_SET_PETITION_ALIVE';
export const COMPARATION_PAGE_INITIALIZE_INSURANCE_CARRIERS_RESPONSES = 'COMPARATION_PAGE_INITIALIZE_INSURANCE_CARRIERS_RESPONSES';
// export const COMPARATION_PAGE_ERRORS = 'COMPARATION_PAGE_ERRORS';
